import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  appendHtmlElementChild,
  CURRENCY_EURO,
  getHtmlElement,
  parseAmount,
  parseBrandName,
  parseCategoryName,
  parseEncasing,
  removeHtmlChild,
  removeHtmlElementClass,
  renderWebComponent,
  setHtmlElementAttribute,
  setHtmlElementContent,
  string2obj,
  titleize
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import tooltipStyles from '../../styles/tooltip.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";


export class SubmissionListContentComponent extends HTMLElement {
  props = {};

  showMiddlemanPrices = true

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }

  connectedCallback() {
    this.eventBus.subscribe('created-new-supplementary-item', (newSupplementaryitem) => {
      this.addSupplementaryItem(newSupplementaryitem, this.props.submissionList.supplementary_items_count - 1);
      this.props.submissionList.supplementary_items.push(newSupplementaryitem);
    });

    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList));

    this.eventBus.subscribe('changed-middleman-price-rendering', (show) => {
      this.showMiddlemanPrices = show;
      this.updateItems();
    });
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList};
    this.updateItems();
  }


  // Funzione che aggiorna i dati renderizzati sull'interfaccia grafica per i vari prodotti presenti all'interno
  // della submission list
  updateItems() {
    for (let i = 0; i < this.props.submissionList.supplementary_items_count; i++) {
      const supplementaryItem = this.props.submissionList.supplementary_items[i];
      this.manageProductGradingPriceRendering(supplementaryItem);
      setHtmlElementContent(this.shadowRoot, `supplementary_item_index_${supplementaryItem.id}`, i+1)
      setHtmlElementContent(this.shadowRoot, `supplementary_item_base_amount_${supplementaryItem.id}`, parseAmount(supplementaryItem[this.props.submissionList.is_middleman_for_company ? 'base_amount_vat_excluded' : 'base_amount'], 2))
      setHtmlElementContent(this.shadowRoot, `supplementary_item_customer_base_amount_${supplementaryItem.id}`, parseAmount(supplementaryItem.customer_base_amount, 2))
      setHtmlElementContent(this.shadowRoot, `supplementary_item_fee_${supplementaryItem.id}`, supplementaryItem.fee);
      setHtmlElementContent(this.shadowRoot, `supplementary_item_customer_fee_${supplementaryItem.id}`, supplementaryItem.fee);
      setHtmlElementContent(this.shadowRoot, `supplementary_item_amount_${supplementaryItem.id}`, parseAmount(supplementaryItem.amount_vat_excluded, 2))
      setHtmlElementContent(this.shadowRoot, `supplementary_item_customer_amount_${supplementaryItem.id}`, parseAmount(supplementaryItem.customer_amount, 2))
    }

    if (this.props.submissionList.supplementary_items_count === 0) {
      removeHtmlElementClass(this.shadowRoot, 'zero-items', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'list-items', 'd-none');
    }
  }


  // Funzione che gestisce il rendering sull'interfaccia grafica del prezzo di gradazione di uno specifico prodotto
  // presente in submission list, eventuali fee applicate dall'azienda di gradazione, o l'eventuale messaggio che
  // spiega all'utente che quel prodotto al momento non è gradabile all'interno nell'involucro scelto
  manageProductGradingPriceRendering(item) {
    if (item.is_gradable) {
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_container_amount_${item.id}`, 'd-none');
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_container_customer_amount_${item.id}`, 'd-none');
      addHtmlElementClass(this.shadowRoot, `supplementary_item_container_not_gradable_${item.id}`, 'd-none');
      if (item.fee && item.fee > 0.0) {
        removeHtmlElementClass(this.shadowRoot, `supplementary_item_container_fee_${item.id}`, "d-none");
        removeHtmlElementClass(this.shadowRoot, `supplementary_item_container_customer_fee_${item.id}`, "d-none");
      }
      else {
        addHtmlElementClass(this.shadowRoot, `supplementary_item_container_fee_${item.id}`, "d-none");
        addHtmlElementClass(this.shadowRoot, `supplementary_item_container_customer_fee_${item.id}`, "d-none");
      }
    } else {
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_container_not_gradable_${item.id}`, 'd-none');
      addHtmlElementClass(this.shadowRoot, `supplementary_item_container_amount_${item.id}`, 'd-none');
      addHtmlElementClass(this.shadowRoot, `supplementary_item_container_customer_amount_${item.id}`, 'd-none');
      addHtmlElementClass(this.shadowRoot, `supplementary_item_container_fee_${item.id}`, 'd-none');
      addHtmlElementClass(this.shadowRoot, `supplementary_item_container_customer_fee_${item.id}`, 'd-none');
    }

    if (!this.props.submissionList.is_middleman_for_company || !this.showMiddlemanPrices) {
      addHtmlElementClass(this.shadowRoot, `supplementary_item_container_amount_${item.id}`, 'd-none')
      addHtmlElementClass(this.shadowRoot, `supplementary_item_customer_amount_msg_${item.id}`, 'd-none')
      addHtmlElementClass(this.shadowRoot, `supplementary_item_amount_msg_${item.id}`, 'd-none')
      addHtmlElementClass(this.shadowRoot, `supplementary_item_vat_included_${item.id}`, 'd-none');
      addHtmlElementClass(this.shadowRoot, `supplementary_item_vat_included_${item.id}`, 'd-none');
    }
    else if (item.is_gradable) {
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_container_amount_${item.id}`, 'd-none')
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_customer_amount_msg_${item.id}`, 'd-none')
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_amount_msg_${item.id}`, 'd-none')
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_vat_included_${item.id}`, 'd-none');
      removeHtmlElementClass(this.shadowRoot, `supplementary_item_vat_included_${item.id}`, 'd-none');
    }
  }


  // Funzione che elimina un certo prodotto dalla submission list
  onDeleteHandler(entity, item) {
    const url = `/${entity}s/${item.id}`;

    fetch(url + ".json", {
      method: "DELETE",
    })
      .then((response) => {
        if (!response.ok)
          throw Error("An error occour during saving data on the database");
        else
          return response.json();
      })
      .then(submissionList => {
        removeHtmlChild(this.shadowRoot, `${entity}_${item.id}`)
        this.eventBus.publish('updated-submission-list-state', submissionList);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        this.eventBus.publish('render-modal', {error: true});
      });
  }


  // Funzione che aggiunge all'interfaccia grafica un nuovo prodotto inserito dall'utente alla sua submission list
  addSupplementaryItem(supplementaryItem, index) {
    const row = document.createElement('template');
    row.innerHTML = `
      <div class="w-100 mx-0 my-5 my-md-3 submission-list-form-initial-sections item-container" id=${'supplementary_item_' + supplementaryItem.id}>
        <div class="d-flex justify-content-center position-relative">
          <div class="item-index">
            <span class="color-light-gray" id=${'supplementary_item_index_' + supplementaryItem.id}>${index + 1}</span>
          </div>
          
          <div class="row border-solid br-20px shadow w-100 mx-0">
            <div class="row w-100 border-top-radius-20px m-0 pt-2 pb-1 pb-md-0 bg-aig-gradient-light border-bottom-solid">
              <div class="col-12 col-sm-6 col-xl-8 text-left color-black tooltip-container">
                <h6 class="d-inline-block text-truncate" style="max-width: 100%">
                  <span id=${'supplementary_item_description_' + supplementaryItem.id}>
                    ${supplementaryItem.description}
                  </span>
                </h6>
                
                <span class="tooltiptext bg-dark-yellow d-none" id=${'supplementary_item_tooltip_' + supplementaryItem.id}>
                  ${supplementaryItem.description}
                </span>
              </div>
              
              <div class="col-12 col-sm-6 col-xl-4 d-flex d-sm-block d-md-flex justify-content-end text-right pl-0">
                <div class="mr-3 mr-sm-0 mr-md-3">
                  <h6 class="mt--3px-imp" id=${'supplementary_item_container_customer_amount_' + supplementaryItem.id}>
                    <small id=${`supplementary_item_customer_amount_msg_${supplementaryItem.id}`}>
                      ${I18n.t('js.editSubmissionListPage.webComponent.draft.amountForCustomer')}:
                    </small>
                    <span id=${'supplementary_item_customer_amount_' + supplementaryItem.id}>${parseAmount(supplementaryItem.customer_amount, 2)}</span>${CURRENCY_EURO}
                    <small id=${'supplementary_item_vat_included_' + supplementaryItem.id}>
                      (${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded')})
                    </small>
                    
                    <p id=${'supplementary_item_container_customer_fee_' + supplementaryItem.id} class="mb-0">
                      <small class="color-dark-gray">
                        <span id=${'supplementary_item_customer_base_amount_' + supplementaryItem.id}>${parseAmount(supplementaryItem.customer_base_amount)}</span>${CURRENCY_EURO}
                        + 
                        <span id=${'supplementary_item_customer_fee_' + supplementaryItem.id}>${supplementaryItem.fee}</span>%
                        ${I18n.t('js.editSubmissionListPage.onDeclaredValue')}
                      </small>
                    </p>
                  </h6>
                  
                  <h6 class="mt--3px-imp" id=${'supplementary_item_container_amount_' + supplementaryItem.id}>
                    <small id=${`supplementary_item_amount_msg_${supplementaryItem.id}`}>
                      ${I18n.t('js.editSubmissionListPage.webComponent.draft.amount')}:
                    </small>
                    <span id=${'supplementary_item_amount_' + supplementaryItem.id}>${parseAmount(supplementaryItem.amount_vat_excluded, 2)}</span>${CURRENCY_EURO}
                    <small id=${'supplementary_item_vat_excluded_' + supplementaryItem.id}>
                      (${I18n.t('js.editSubmissionListPage.webComponent.draft.vatExcluded')})
                    </small>
                    
                    <p id=${'supplementary_item_container_fee_' + supplementaryItem.id} class="mb-0">
                      <small class="color-dark-gray">
                        <span id=${'supplementary_item_base_amount_' + supplementaryItem.id}>${parseAmount(supplementaryItem.base_amount_vat_excluded)}</span>${CURRENCY_EURO}
                        + 
                        <span id=${'supplementary_item_fee_' + supplementaryItem.id}>${supplementaryItem.fee}</span>%
                        ${I18n.t('js.editSubmissionListPage.onDeclaredValue')}
                        <small id=${'supplementary_item_vat_excluded_' + supplementaryItem.id}>
                          (${I18n.t('js.editSubmissionListPage.webComponent.draft.vatExcluded')})
                        </small>
                      </small>
                    </p>
                  </h6>
                  
                  
                  
                  <h6 class="mb-3 color-dark-orange" id=${'supplementary_item_container_not_gradable_' + supplementaryItem.id}>
                    <span>${I18n.t('js.editSubmissionListPage.webComponent.draft.notGradableProduct')} ${parseEncasing(supplementaryItem.encasing, supplementaryItem.category.name).toUpperCase()}</span>
                  </h6>
                </div>
                
                <img src="/images/icons/close.svg" 
                  alt="" width="15" height="15" 
                  class="cursor-pointer" 
                  id=${'supplementary_item_' + supplementaryItem.id + '_trash'}
                >
              </div>
            </div>
              
            <div class="row w-100 m-0">
              <div class="col-6 col-lg-3 text-left border-right-solid border-bottom-solid py-1">
                <small class="color-gray">${I18n.t("js.advancedSearch.filterComponent.brand").toUpperCase()}</small><br>
                ${parseBrandName(supplementaryItem.brand?.name)}
              </div>
              
              <div class="col-6 col-lg-3 text-left border-bottom-solid py-1">
                <small class="color-gray">${I18n.t("js.advancedSearch.productProperty.productType").toUpperCase()}</small><br>
                ${parseCategoryName(supplementaryItem.category.name)}
              </div>
              
              <!--
              <div class="col-6 col-lg-3 text-left border-left-lg-solid border-right-solid border-bottom-solid py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.estimatedValue').toUpperCase()}</small><br>
                ${parseAmount(supplementaryItem.estimated_value, 2)}${CURRENCY_EURO}
              </div>
              -->
              
              <div class="col-6 col-lg-3 text-left border-left-lg-solid border-right-solid border-bottom-solid py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.encasing').toUpperCase()}</small><br>
                ${titleize(parseEncasing(supplementaryItem.encasing, supplementaryItem.category.name).toLowerCase())}
              </div>
              
              <div class="col-6 col-lg-3 text-left border-bottom-solid py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.serviceRequested').toUpperCase()}</small><br>
                ${I18n.t(`js.editSubmissionListPage.webComponent.draft.service.${supplementaryItem.requested_service}`)}
              </div>
              
              <div class="col-6 col-lg-3 text-left border-right-solid py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.labelType').toUpperCase()}</small><br>
                ${I18n.t(`js.editSubmissionListPage.webComponent.draft.labelTypeOption.${supplementaryItem.label_type}`)}
              </div>
              
              <div class="col-6 col-lg-3 text-left py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.labelLanguage').toUpperCase()}</small><br>
                ${I18n.t(`js.editSubmissionListPage.webComponent.draft.labelLanguageOption.${supplementaryItem.label_language}`)}
              </div>
              
              <div class="col-6 col-lg-3 text-left border-left-lg-solid border-right-solid border-top-solid border-top-lg-none py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.authenticateIf').toUpperCase()}</small><br>
                ${
                  supplementaryItem.grading_lower_limit ?
                    I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThen') + ' ' + supplementaryItem.grading_lower_limit
                    :
                    I18n.t('js.editSubmissionListPage.webComponent.draft.na2')
                }
              </div>
              
              <div class="col-6 col-lg-3 text-left border-top-solid border-top-lg-none py-1">
                <small class="color-gray">${I18n.t('js.editSubmissionListPage.webComponent.draft.sleeveIf').toUpperCase()}</small><br>
                ${
                  supplementaryItem.case_lower_limit ?
                    I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThen')+ ' ' + supplementaryItem.case_lower_limit
                    :
                    I18n.t('js.editSubmissionListPage.webComponent.draft.na2')
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    `
    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'list-items'), row.content.cloneNode(true));
    this.manageProductGradingPriceRendering(supplementaryItem);
    addHtmlElementEventListener(this.shadowRoot, `supplementary_item_${supplementaryItem.id}_trash`, 'click', (e) => this.onDeleteHandler('supplementary_item', supplementaryItem));
    addHtmlElementEventListener(this.shadowRoot, `supplementary_item_${supplementaryItem.id}_trash`, 'mouseover', (e) => setHtmlElementAttribute(this.shadowRoot, `supplementary_item_${supplementaryItem.id}_trash`, "src", "/images/icons/close_danger.svg"));
    addHtmlElementEventListener(this.shadowRoot, `supplementary_item_${supplementaryItem.id}_trash`, 'mouseout', (e) => setHtmlElementAttribute(this.shadowRoot, `supplementary_item_${supplementaryItem.id}_trash`, 'src', "/images/icons/close.svg"));

    addHtmlElementClass(this.shadowRoot, 'zero-items', 'd-none');
    removeHtmlElementClass(this.shadowRoot, 'list-items', 'd-none');

    addHtmlElementEventListener(this.shadowRoot, `supplementary_item_description_${supplementaryItem.id}`, 'mouseover', (e) => removeHtmlElementClass(this.shadowRoot, `supplementary_item_tooltip_${supplementaryItem.id}`, 'd-none'));
    addHtmlElementEventListener(this.shadowRoot, `supplementary_item_description_${supplementaryItem.id}`, 'mouseout', (e) => addHtmlElementClass(this.shadowRoot, `supplementary_item_tooltip_${supplementaryItem.id}`, 'd-none'));
  }


  render() {
    const html = `
      <div class="row w-100 m-0" id="zero-items">
        <div class="col-1 col-lg-3"></div>
        
        <div class="col-10 col-lg-6 pl-0">    
          <div class="row d-flex justify-content-center text-center text-aig-gradient pt-4">
            <h2><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.itemsTitle')}</b></h2>
          </div>
        </div>
        
        <div class="col-1 col-lg-3"></div>
      </div>
      
      <div id="list-items" class="px-0"></div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, tooltipStyles, submissionListsStyles]);

    for (let i = 0; i < this.props.submissionList.supplementary_items_count; i++)
      setTimeout(() => this.addSupplementaryItem(this.props.submissionList.supplementary_items[i], i), 100 * i);
  }
}

window.customElements.define("submission-list-content-component", SubmissionListContentComponent);